export default __webpack_public_path__ + "static/media/gallery-3.909167b7.png";